module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/assessment_achievements/4_7bbb80e5d86cb5e484c06b4524457e9f.png";